
import { useEffect } from 'react'
import Select from 'react-select'
import { DepartmentDDLAPI, EmployeeDDLAPI, JunctionNameDDLAPI, LocationNameDDLAPI, PipelineDDLAPI, SectorDDLAPI, WardNameDDLAPI, WaterSupplyWorkTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WaterSupplyWorkTypeDataDDL = (props) => {
    const { WSWorkType, setWSWorkType, JunctionNameDDL, PopUpField, IsPost, WardName, DashProjectTypeId, rowData, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterSupplyWorkTypeDDLAPI({ data }))
    }, [IsPost])

    const { WaterSupplyWorkTypeData } = useSelector(state => state.WaterSupplyWorkTypeDDLData)

    useEffect(() => {
        handleWorkTypeDDL()
    }, [WaterSupplyWorkTypeData])

    const handleWorkTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (WaterSupplyWorkTypeData && WaterSupplyWorkTypeData.table && WaterSupplyWorkTypeData.table.length > 0) {
            if (DashProjectTypeId == 6 && RoleID != '16') {
                let list = WaterSupplyWorkTypeData.table.map((item, index) => ({
                    value: item.m_Distri_WorkTypeID,
                    label: item.workType,
                }))
                setWSWorkType({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_Distri_WorkTypeID : 0,
                    Label: Flag === 'Update' ? rowData.workType : "Select...",
                })
            } else {
                let list = WaterSupplyWorkTypeData.table.map((item, index) => ({
                    value: item.m_wS_WorkTypeID,
                    label: item.workType,
                }))
                setWSWorkType({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_wS_WorkTypeID : 0,
                    Label: Flag === 'Update' ? rowData.workType : "Select...",
                })
            }


        }
        else {
            setWSWorkType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Work Type </b></label>
            <Select
                isSearchable
                isClearable
                maxMenuHeight={150}
                value={{ value: WSWorkType.ID, label: WSWorkType.Label }}
                onChange={(e) => {
                    e ?
                        setWSWorkType({ ...WSWorkType, ID: e.value, Label: e.label })
                        :
                        setWSWorkType({ ...WSWorkType, ID: 0, Label: "Select..." })

                }}
                options={WSWorkType.DDL}
            />
        </div>
    )
}